module.exports = __webpack_public_path__ + "static/media/tawuniya-logo.bfe5d8b3.svg";